import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import PusherLink from 'graphql-ruby-client/subscriptions/PusherLink';
import Pusher from 'pusher-js';
import apiClient from 'apiClient';
import introspectionQueryResultData from './fragmentTypes.json';

import { PAYMENT_REQUIRED } from 'constants/appEvents';
import EventEmitter from 'helpers/event-emitter';

Pusher.logToConsole = process.env.NODE_ENV === 'development';

const pusherClient = new Pusher(process.env.PUSHER_APP_KEY, {
  cluster: process.env.PUSHER_CLUSTER,
  encrypted: true,
  authorizer: (channel, _) => ({
    authorize: (socket_id, callback) => {
      apiClient
        .post('/pusher/auth', {
          channel_name: channel.name,
          socket_id,
        })
        .then((response) => {
          callback(false, response);
        })
        .catch((error) => {
          callback(true, error);
        });
    },
  }),
});

export const initGraphQLClient = () => {
  const pusherLink = new PusherLink({ pusher: pusherClient });

  const httpLink = new HttpLink({
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        ),
      );
    }

    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      if (networkError.statusCode === 402) {
        EventEmitter.trigger(PAYMENT_REQUIRED);
      }
    }
  });

  const cache = new InMemoryCache({
    possibleTypes: introspectionQueryResultData,
  });

  const client = new ApolloClient({
    link: ApolloLink.from([pusherLink, errorLink, httpLink]),
    cache,
    connectToDevTools: process.env.NODE_ENV === 'development',
  });

  return client;
};
